{
  "rbc": "Red blood cells",
  "hemoglobin": "Hemoglobin",
  "hematocrit": "Hematocrit",
  "mcv": "Mean corpuscular volume",
  "mch": "Mean corpuscular hemoglobin",
  "mchc": "Mean corpuscular hemoglobin concentration",
  "rdw": "Red cell distribution width",
  "wbc": "White blood cells",
  "platelets": "Platelets",
  "mpv": "Mean platelet volume",
  "neutrophils_pct": "Neutrophils %",
  "neutrophils_abs": "Neutrophils absolute",
  "lymphocytes_pct": "Lymphocytes %",
  "lymphocytes_abs": "Lymphocytes absolute",
  "monocytes_pct": "Monocytes %",
  "monocytes_abs": "Monocytes absolute",
  "eosinophils_pct": "Eosinophils %",
  "eosinophils_abs": "Eosinophils absolute",
  "basophils_pct": "Basophils %",
  "basophils_abs": "Basophils absolute",
  "glucose": "Glucose (fasting)",
  "hba1c": "Glycated hemoglobin",
  "creatinine": "Creatinine",
  "urea": "Urea",
  "uric_acid": "Uric acid",
  "egfr": "Estimated glomerular filtration rate",
  "cholesterol_total": "Total cholesterol",
  "ldl": "LDL cholesterol",
  "hdl": "HDL cholesterol",
  "triglycerides": "Triglycerides",
  "non_hdl": "Non-HDL cholesterol",
  "apob": "Apolipoprotein B",
  "ast": "Aspartate aminotransferase",
  "alt": "Alanine aminotransferase",
  "ggt": "Gamma-glutamyl transferase",
  "alp": "Alkaline phosphatase",
  "bilirubin_total": "Total bilirubin",
  "bilirubin_direct": "Direct bilirubin",
  "sodium": "Sodium",
  "potassium": "Potassium",
  "calcium": "Total calcium",
  "magnesium": "Magnesium",
  "phosphorus": "Phosphorus",
  "iron": "Serum iron",
  "ferritin": "Ferritin",
  "transferrin": "Transferrin",
  "tsat": "Transferrin saturation",
  "tsh": "Thyroid-stimulating hormone",
  "free_t4": "Free thyroxine",
  "vitamin_d": "Vitamin D (25-OH)",
  "vitamin_b12": "Vitamin B12",
  "folate": "Folate",
  "testosterone": "Total testosterone",
  "cortisol": "Cortisol",
  "ck": "Creatine kinase",
  "hs_crp": "High-sensitivity CRP"
}
